import { useState, useEffect } from 'react';
import { useAppContext } from 'QuoteApp/services/providers';

type UseRefreshDataOnMountType = {
  force: boolean;
};

const defaultOptions: UseRefreshDataOnMountType = { force: false };

/**
 * Details can change report statuses after running rate
 * Most update requests return details, then we call rate
 * Only the reports page is affected, calling details again after every rate call would be inefficient
 * This allows the report page to wait until in-flight rate calls finish, then get accurate report statuses
 */
export const useRefreshDataOnMount = (options?: UseRefreshDataOnMountType) => {
  const {
    refreshDetails,
    detailsLoading,
    refreshRate,
    rate,
    rateLoading,
    rateError,
  } = useAppContext();
  const [loading, setLoading] = useState<boolean>(true);
  const rateHasLoaded = !!(rate || rateError);
  const { force = false } = options || defaultOptions;

  useEffect(() => {
    if (force || (!rateHasLoaded && !rateLoading)) {
      refreshRate();
    }
    // Only call on load if there isn't one
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [force]);

  useEffect(() => {
    if (rateHasLoaded && !rateLoading && !detailsLoading && loading) {
      refreshDetails().then(() => setLoading(false));
    }
  }, [detailsLoading, loading, rateHasLoaded, rateLoading, refreshDetails]);

  return { loading };
};
